import CreateFlagContainer from "./CreateFlagContainer";
export default CreateFlagContainer;
